"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createVimeoContentStyle;

function createVimeoContentStyle(_ref) {
  var videoHeight = _ref.videoHeight;
  return {
    border: 0,
    height: videoHeight,
    width: '100%'
  };
}